import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
export function WhyWeExist() {
  return <section id="why-we-exist" className="py-20 md:py-28 border-t border-border" data-id="element-113">
      <div className="container" data-id="element-114">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center" data-id="element-115">
          <SectionHeading eyebrow="Why we exist" title="A deck is not a system." className="max-w-xl" data-id="element-116" />
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="space-y-5 border-l border-border pl-6 md:pl-8" data-id="element-117">
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed" data-id="element-118">
              We kept watching the same story play out: a promising AI
              initiative, a beautiful strategy deck, an eighteen-month roadmap —
              and nothing in production.
            </p>
            <p className="text-base md:text-lg text-foreground leading-relaxed font-medium" data-id="element-119">
              The fix, we think, is unglamorous. Put engineers next to the
              problem. Build on real data from week one.
            </p>
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed" data-id="element-120">
              Let a working system make the argument, and let the strategy be
              written about something that already exists.
            </p>
          </motion.div>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="bracket-frame mt-14 md:mt-20 relative overflow-hidden border border-border h-64 md:h-[420px]" data-id="element-121">
          <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=2000&auto=format&fit=crop" alt="Engineers reviewing a roadmap on a whiteboard, working session in progress" className="w-full h-full object-cover grayscale contrast-125" data-id="element-122" />
          <div className="absolute inset-0 bg-background/50 mix-blend-multiply" data-id="element-123" />
          <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/10 to-transparent" data-id="element-124" />
          <div className="absolute bottom-6 left-6 right-6 md:bottom-8 md:left-8 md:right-8" data-id="element-125">
            <p className="font-heading text-foreground text-lg md:text-2xl font-medium max-w-md leading-snug" data-id="element-126">
              Strategy gets written after the software works.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}